import { useState } from 'react'
import cn from 'classnames'
import { Field, useField, useFormikContext } from 'formik'
import { keyBy } from 'lodash'

import Select from 'components/Select'
import TextBox from 'components/TextBox'
import Loader from 'components/Loader'

import { TIME_ZONES } from 'resources'
import { createRevenueCenterImageUrl } from 'utils/revenueCenters/links.js'

const Info = ({ id, showValidationErrors, revenueCenterUuid }) => {
  const timeZones = TIME_ZONES

  const [isImageValid, setIsImageValid] = useState(true)
  const [isImageLoading, setIsImageLoading] = useState(true)

  const { values, setFieldValue } = useFormikContext()

  const timeZonesByUuid = keyBy(TIME_ZONES, 'uuid')
  const timeZonesByValue = keyBy(TIME_ZONES, 'value')

  const [field, fieldMeta, fieldHelpers] = useField('localTime')

  return (
    <section id={id}>
      <div
        className={cn('loader-wrapper', {
          hidden: !isImageLoading,
        })}
      >
        <Loader container={false} />
      </div>
      <div className={cn('content-wrapper')}>
        <Field
          component={TextBox}
          label="Name *"
          name="name"
          showValidationErrors={showValidationErrors}
        />
      </div>
      <div className="content-wrapper">
        <Field
          component={TextBox}
          label="External Ref ID"
          name="externalRefId"
        />
      </div>
      <div className="content-wrapper">
        <Field
          component={TextBox}
          label="Description"
          name="description"
        />
      </div>
      {isImageValid && (
        <div className="image-field">
          <img
            className="image-field__image"
            src={createRevenueCenterImageUrl(revenueCenterUuid)}
            alt="revenue center"
            onLoad={() => setIsImageLoading(false)}
            onError={() => {
              setIsImageLoading(false)
              setIsImageValid(false)
            }}
          />
        </div>
      )}
      <div className={cn('content-wrapper')}>
        <Field
          component={Select}
          options={timeZones}
          handleChange={(value) => {
            setFieldValue('localTime', timeZonesByUuid[value]?.value)
          }}
          defaultValue={timeZonesByValue[values.localTime]?.uuid}
          label="Time Zone *"
          fieldName="localTime"
          name="localTime"
          error={fieldMeta.error}
          showValidationErrors={showValidationErrors}
        />
      </div>
    </section>
  )
}

export default Info
